<template>
  <main id="home">
    <hero />
    <reasons />
    <media />
    <business />
    <strategy/>
    <cta/>
    <team/>
    <advantage/>
    <invest/>
    <disclaimer/>
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import hero from '@/components/hero.vue';
import reasons from '@/components/reasons.vue';
import media from '@/components/media.vue';
import business from '@/components/business.vue';
import disclaimer from '@/components/disclaimer.vue';
import strategy from '@/components/strategy.vue';
import cta from '@/components/cta.vue';
import team from '@/components/team.vue';
import advantage from '@/components/advantage.vue';
import invest from '@/components/invest.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    hero,
    reasons,
    media,
    business,
    disclaimer,
    strategy,
    cta,
    team,
    advantage,
    invest
},
  mounted() {
  },
};
</script>
